<template>
  <div
    v-if="orderSummary"
    class="kt-login__signin col-sm-12 col-md-12 col-lg-10 col-xl-8 col-12 mx-auto"
  >
    <div class="kt-head px-0 pb-4">
      <p class="text-primary font-weight-bold mb-1">
        Congratulations, {{ orderSummary.user.name + "!" }}
      </p>
      <h3 class="h2 text-dark">{{ headingText }}</h3>
      <p class="mt-3">{{ summaryText }}</p>
    </div>
    <div>
      <Alert v-if="successMessage" variant="success">
        {{ successMessage }}
      </Alert>

      <Alert v-if="errorMessage" variant="danger">
        {{ errorMessage }}
      </Alert>

      <form class="kt-form" @submit.prevent="submit">
        <div class="form-group" style="opacity:.6">
          <label>Email</label>
          <input
            type="email"
            placeholder="Email"
            v-model="form.email"
            disabled
            class="form-control disabled"
          />
        </div>

        <div class="form-group">
          <label>New Password</label>
          <input
            type="password"
            v-model="form.password"
            required
            class="form-control"
            :class="{ 'is-invalid': hasError('password') }"
            @input="clearError('password')"
          />
          <div v-if="hasError('password')" class="invalid-feedback">
            {{ getError("password") }}
          </div>
        </div>

        <div class="form-group">
          <label>Confirm New Password</label>
          <input
            type="password"
            v-model="form.password_confirmation"
            required
            class="form-control"
            :class="{ 'is-invalid': hasError('password_confirmation') }"
            @input="clearError('password_confirmation')"
          />
          <div
            v-if="hasError('password_confirmation')"
            class="invalid-feedback"
          >
            {{ getError("password_confirmation") }}
          </div>
        </div>

        <div class="form-group">
          <button
            type="submit"
            id="kt_login_signin_submit"
            class="btn btn-brand w-100 btn-elevate"
            :disabled="busy"
          >
            <div class="d-flex justify-content-center align-items-center">
              <span>{{ btnText }}</span>
              <div
                v-if="busy"
                class="spinner-border spinner-border-sm ml-2"
                role="status"
              >
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Alert from "@/components/Alert.vue";
import OrderStatus from "@/types/orderStatus.js";
import ValidationErrorsMixin from "@/mixins/ValidationErrors.js";

export default {
  components: {
    Alert,
  },

  mixins: [ValidationErrorsMixin],

  props: {
    orderSummary: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      form: {
        email: "",
        password: "",
        password_confirmation: "",
      },
      errors: {},
      successMessage: "",
      errorMessage: "",
      busy: false,
    };
  },

  computed: {
    isOrderQuotation() {
      return !!this.orderSummary.is_quotation || false;
    },
    isOrderQuoteSubmitted() {
      return this.orderSummary.status === OrderStatus.QuoteSubmitted;
    },
    isOrderComplete() {
      return this.orderSummary.status === OrderStatus.Complete;
    },
    headingText() {
      if (this.isOrderQuotation && this.isOrderQuoteSubmitted) {
        return `Quotation ready for review - ${this.orderSummary.id}`;
      }
      if (!this.isOrderQuotation && this.isOrderComplete) {
        return `Order ${this.orderSummary.id} is ready for download.`;
      }
      return "";
    },
    summaryText() {
      if (this.isOrderQuotation && this.isOrderQuoteSubmitted) {
        return `Create a password to review price per image.`;
      }
      if (!this.isOrderQuotation && this.isOrderComplete) {
        return `Create a password to download your files.`;
      }
      return "";
    },
    btnText() {
      return this.isOrderQuotation ? "Login & Review" : "Login & Download";
    },
  },

  mounted() {
    this.form.email = this.orderSummary.user.email;
  },

  methods: {
    ...mapActions({
      guestUpdatePassword: "auth/guestUpdatePassword",
    }),
    submit() {
      if (this.busy) {
        return;
      }
      this.busy = true;

      this.guestUpdatePassword(this.form)
        .then(() => {
          this.$router.replace({
            name: "order-details",
            params: {
              id: this.orderSummary.id,
            },
          });
        })
        .catch((error) => {
          if (error.response?.status === 422) {
            this.errors = error.response.data.errors;
          }
        })
        .finally(() => (this.busy = false));
    },
  },
};
</script>
